import React from "react";
import { Link } from "react-router-dom";

export default function DesktopWaffleMenu({
  waffleItems,
  waffleOpen,
  setWaffleOpen,
  waffleRef,
  menuRef,
  buttonRef,
  closeAll,
  safeT,
}) {
  return (
    <div className="relative hidden md:block" ref={waffleRef}>
      
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setWaffleOpen((state) => !state)}
        className="h-10 w-10 rounded-xl text-primary hover:text-foreground hover:bg-muted transition flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        aria-haspopup="true"
        aria-expanded={waffleOpen}
        aria-controls="desktop-waffle-menu"
        aria-label={safeT("navbar.systemsMenu", "Open systems menu")}
      >
        <span className="sr-only">{safeT("navbar.systemsMenu", "Open systems menu")}</span>
        <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true" fill="currentColor">
          <rect x="3" y="3" width="4" height="4" rx="1" />
          <rect x="10" y="3" width="4" height="4" rx="1" />
          <rect x="17" y="3" width="4" height="4" rx="1" />
          <rect x="3" y="10" width="4" height="4" rx="1" />
          <rect x="10" y="10" width="4" height="4" rx="1" />
          <rect x="17" y="10" width="4" height="4" rx="1" />
          <rect x="3" y="17" width="4" height="4" rx="1" />
          <rect x="10" y="17" width="4" height="4" rx="1" />
          <rect x="17" y="17" width="4" height="4" rx="1" />
        </svg>
      </button>

      {waffleOpen && (
        /* DROPDOWN MENU CONTAINER WITH RIGHT SCROLLBAR */
        <div
          id="desktop-waffle-menu"
          ref={menuRef}
          role="menu"
          aria-label={safeT("navbar.systemsMenu", "Systems menu")}
          className="absolute right-0 mt-2 w-[52rem] max-w-[calc(100vw-2.5rem)] max-h-[calc(100vh-6rem)] overflow-y-auto bg-card text-card-foreground rounded-2xl shadow-[0_26px_52px_rgba(0,0,0,0.14)] dark:shadow-[0_26px_52px_rgba(0,0,0,0.55)] border border-border p-5 z-50 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-card [&::-webkit-scrollbar-thumb]:bg-muted-foreground/60 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-primary"
        >
          <div className="px-1 pb-4 flex items-center justify-between gap-4">
            {/* MENU HEADINGS */}
            <h2 className="text-2xl font-bold tracking-tight text-primary">
              {safeT("navbar.waffle.description", "Your Orrith")}
            </h2>
            <span className="text-lg font-bold text-primary">
              {safeT("navbar.waffle.explore", "Explore our ecosystem")}
            </span>
          </div>

          {/* 2 COLUMNS PER ROW */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {waffleItems.map(({ id, title, subtitle, to, Icon }) => (
              /* LINK CARD ITEM */
              <Link
                key={id}
                to={to}
                role="menuitem"
                data-menu-autofocus={id === waffleItems[0]?.id ? "true" : undefined}
                onClick={closeAll}
                className="group rounded-xl border border-border bg-card hover:border-primary hover:bg-background transition px-4 py-3.5 flex items-start justify-between gap-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset"
              >
                <div className="flex items-start gap-3 min-w-0 flex-1">
                  {/* ICON WRAPPER */}
                  <span className="h-11 w-11 rounded-xl bg-primary text-primary-foreground inline-flex items-center justify-center border border-primary flex-shrink-0">
                    <Icon size={19} aria-hidden="true" />
                  </span>

                  <span className="min-w-0 flex-1">
                    <span className="block text-[1.02rem] leading-5 font-semibold text-card-foreground group-hover:text-primary transition-colors">
                      {title}
                    </span>
                    <span className="mt-1 block text-[0.88rem] leading-4 text-muted-foreground">
                      {subtitle}
                    </span>
                  </span>
                </div>

                {/* RIGHT ARROW */}
                <span className="text-muted-foreground group-hover:text-primary text-lg leading-none mt-0.5 flex-shrink-0 transition-colors" aria-hidden="true">
                  ›
                </span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}